import { msg } from '@lingui/core/macro';
import { updateDevice } from 'modules/devices/store/actions';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store/hooks';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';

export function useUpdateDevice(refetch: () => void) {
  const { t } = useLingui();
  const toastApiError = useToastApiError();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (id: number, params: Partial<{ name: string; tournament_id: number }>) => {
      setIsLoading(true);
      try {
        await dispatch(updateDevice({ id, params })).unwrap();
        toast.success(t`Устройство обновлено`);
        refetch();
      } catch (error) {
        toastApiError(error, msg`Не удалось обновить устройство`);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, refetch, t, toastApiError],
  );

  return { mutate, isLoading };
}
